import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, Tooltip, Typography, Box } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import CheckIcon from '@mui/icons-material/Check';

const LANGUAGES = [
  { code: 'en', label: 'English', native: 'English' },
  { code: 'ta', label: 'Tamil', native: 'தமிழ்' },
];

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (code) => {
    if (code === i18n.language) {
      handleClose();
      return;
    }
    try {
      localStorage.setItem('i18nextLng', code);
    } catch (e) { /* ignore */ }
    i18n.changeLanguage(code).finally(() => {
      handleClose();
      window.location.reload();
    });
  };

  return (
    <>
      <Tooltip title={`${t('common.language')}: ${currentLang.native}`}>
        <IconButton color="inherit" onClick={handleOpen} size="small" sx={{ ml: 1 }}>
          <TranslateIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={i18n.language === lang.code}
            onClick={() => handleSelect(lang.code)}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" fontWeight={i18n.language === lang.code ? 700 : 400}>
                  {lang.native}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {lang.label}
                </Typography>
              </Box>
              {i18n.language === lang.code && (
                <CheckIcon fontSize="small" color="primary" />
              )}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
